import React, { useState } from 'react'
import { useQuery } from 'react-query'
import { Box, Typography } from '@mui/material'

// Local Imports
import AdxInfoModal from 'components/reusable/modal/AdxInfoModal'
import AdxSwitch from 'components/reusable/switch/AdxSwitch'

// API services
import { getLeavePolicies, usePutLeavePolicyStatus } from 'services/api/modules/leave/leavePolicy'
import AdxInfoIcon from 'components/custom/AdxInfoIcon'
import AdxButton from 'components/custom/AdxButton'

const LeaveCreditStatus = () => {
  const [modalState, setModalState] = useState(false)
  const { data } = useQuery(['leave-policy', { type: 3 }], async () => {
    const { data: apiData } = await getLeavePolicies()
    return apiData.data.leave_credit[0]
  })

  const mutation = usePutLeavePolicyStatus()

  const handleOpen = () => {
    setModalState(true)
  }

  const handleClose = () => {
    setModalState(false)
  }

  const handleChange = () => {
    // API to mutate status here
    if (data.status === 1) {
      mutation.mutate(
        { status: 2, id: data.id, type: data.type },
        {
          onSuccess: () => handleClose(),
        }
      )
    } else {
      mutation.mutate(
        { status: 1, id: data.id, type: data.type },
        {
          onSuccess: () => handleClose(),
        }
      )
    }
  }

  if (data?.status === 3) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Typography>{data?.status_name}</Typography>
        <AdxInfoIcon
          toolTipTitle={'Please review the configurations in manage leave policy page'}
        />
      </Box>
    )
  }

  return (
    <>
      <AdxSwitch
        state={data?.status === 1 ? true : false}
        onClick={handleOpen}
        label1="Enabled"
        label2="Disabled"
      />
      <AdxInfoModal
        title={
          data?.status === 1
            ? 'Are you sure you want to disable this setting'
            : 'Are you sure you want to enable this setting?'
        }
        subtitle="Changes may affect settings"
        muiIcon="error"
        iconColor={data?.status === 2 ? 'info.main' : 'error.main'}
        open={modalState}
        onClose={handleClose}
      >
        <AdxButton
          variant={'outlined'}
          color="error"
          sx={{
            '&:hover': {
              backgroundColor: 'light-error.main',
            },
          }}
          fullWidth
          onClick={handleChange}
          type="submit"
        >
          {data?.status === 1 ? 'Disable' : 'Enable'}
        </AdxButton>
        <AdxButton
          variant={'ghost'}
          sx={{ color: 'light-gray-text.main' }}
          fullWidth
          onClick={handleClose}
        >
          Cancel
        </AdxButton>
      </AdxInfoModal>
    </>
  )
}

export default LeaveCreditStatus
